/**
 * Reads the version of the latest deployed build from `/version.json` (bypassing every cache).
 * Returns `null` when it cannot be read, so a network hiccup never triggers a false "update" alert.
 */
export const fetchLatestVersion = async (): Promise<string | null> => {
  try {
    const response = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' });

    if (!response.ok) {
      return null;
    }

    const data: unknown = await response.json();

    return typeof data === 'object' && data !== null && 'version' in data && typeof data.version === 'string'
      ? data.version
      : null;
  } catch {
    return null;
  }
};
